import { createGlobalStyle } from 'styled-components';
import COLORS from '../../utils/Colors';

const GlobalStyles = createGlobalStyle`
  body {
    font-family: 'Montserrat', sans-serif;
    margin: 0;
  }

  html {
    margin: 0;

    & p {
      margin: 0;
    }

    & a:link{
      text-decoration: none!important;
    }
  }

  // Styles for react-day-picker
  :root {
    --rdp-cell-size: 4vw;
    width: 100vw;
    --rdp-accent-color: ${COLORS.mainTeal};
    --rdp-background-color: ${COLORS.mainTealLight};
    /* Switch to dark colors for dark themes */
    --rdp-accent-color-dark: #3003e1;
    --rdp-background-color-dark: #180270;
    /* Outline border for focused elements */
    --rdp-outline: 2px solid ${COLORS.mainTeal};
    /* Outline border for focused and selected elements */
    --rdp-outline-selected: 1px solid rgba(0, 0, 0, 0.4);
  }

  .rdp-cell {
    width: var(--rdp-cell-size);
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 1vw;
    text-align: center;
  }

  @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
    :root {
      --rdp-cell-size: 7vw;
    }
      .rdp-cell {
        padding: 2.6vw;
      }
  };

  @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
    :root {
    --rdp-cell-size: 11vw;
  }
    .rdp-cell {
      padding: 1vw;
    }
  };
`

export default GlobalStyles